import { Node } from "../../../../../../../../types";

export const getAllPartsValue = (node: Node, side: number) => {
  if (node.type === 'single') {
    const values = Object.values(node.partsSingle || {});
    const firstValue = values[0];

    if (values.every((value) => value === firstValue)) {
      return firstValue;
    }
  } else if (node.type === '4-sides') {
    const values = Object.values(node.parts4Side || {});
    const firstValue = values[0][side === 4 ? 0 : side || 0];

    if (side < 4 && values.every((value) => value[side] === firstValue)) {
      return firstValue;
    } else if (side === 4 && values.every((value) =>  value.every((v) => v === firstValue))) {
      return firstValue;
    }
  }
};

export const getCommonPartValue = (node: Node, part: string) => {
  const firstValue = node.parts4Side?.[part]?.[0];

  if (node.parts4Side && node.parts4Side[part].every((value) => value === firstValue)) {
    return firstValue;
  }
};

export const allSidesEqual = (node: Node) => Object.values(node.parts4Side || {})
  .every((value) => value.every((v) => v === value[0]));

export const checkOneWholePart = (node: Node) => {
  if (node.type === 'single' && Object.values(node.partsSingle || {}).filter((value) => value === 'whole').length === 1) {
    return true;
  } else if (node.type === '4-sides') {
    for (let i = 0; i < 4; i++) {
      if (Object.values(node.parts4Side || {}).filter((value) => value[i] === 'whole').length === 1) {
        return true;
      }
    }
  } else {
    if (Object.values(node.partsWheels || {}).filter((value) => value[1] === 'whole').length === 1) {
      return true;
    }
  }
};

export const removeOneWholePart = (node: Node): Partial<Node> => {
  if (node.type === 'single' && Object.values(node.partsSingle || {}).filter((value) => value === 'whole').length === 1) {
    return {
      partsSingle: Object.fromEntries(Object.entries(node.partsSingle || {})
        .map(([name, value]) => [name, value === 'whole' ? 'apart' : value])),
    };
  } else if (node.type === '4-sides') {
    return {
      parts4Side: Object.fromEntries(Object.entries(node.parts4Side || {})
        .map(([name, value]) => [name, [
          value[0] === 'whole' ? 'apart' : value[0],
          value[1] === 'whole' ? 'apart' : value[1],
          value[2] === 'whole' ? 'apart' : value[2],
          value[3] === 'whole' ? 'apart' : value[3],
        ]])),
    };
  } else {
    return {
      partsWheels: Object.fromEntries(Object.entries(node.partsWheels || {})
        .map(([name, value]) => [name, {
          count: value[0],
          dismantlingType: value[1] === 'whole' ? 'apart' : value[1],
          complect: value[2],
        }])),
    };
  }
};
